// extracted by mini-css-extract-plugin
export var closeButton = "_c-1";
export var container = "_c-0";
export var fullModalImage = "_c-2";